import React from 'react';
import 'flag-icons/css/flag-icons.min.css';

const FlagIcon = ({ code, className }) => (
  <span className={`fi fi-${code?.toLowerCase()} ${className || ''}`.trim()} />
);

export default FlagIcon;
